<!-- Footer Start -->
<div class="el-footer-wrapper">
    <div class="container">
        <div class="row gy-4">

            <div class="col-lg-6 col-md-6">
                <div class="el-footer-info">
                    <a [routerLink]="['/']"><img src="../assets/images/all-instructor/logo-f.svg" alt="logo"
                            width="200px"></a>
                    <p class="el-para" style="width: 100%;">We believe every student has the potential to excel. The
                        PowerPrep Olympiad Mock Test is crafted to ignite curiosity,
                        build confidence, and prepare students for Olympiad academic success. Through our structured
                        mock test platform and
                        high-quality study materials, we empower learners to aim higher, think deeper, and strive for
                        excellence, today and for
                        a lifetime.


                    </p>
                    <div class="el-social-icons">
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/silverzoneolympiads" target="_blank">
                                    <svg width="10" height="16" viewBox="0 0 8 14">
                                        <path
                                            d="M4.61903 13.1094V7.13001H6.71611L7.03074 4.79906H4.61903V3.31108C4.61903 2.63643 4.81405 2.17666 5.82647 2.17666L7.11562 2.17615V0.0912609C6.89268 0.0635446 6.1274 0 5.2367 0C3.37678 0 2.10344 1.08609 2.10344 3.08022V4.79906H0V7.13001H2.10344V13.1094H4.61903Z" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/SilverZoneOlympiads" target="_blank"
                                    style="background-color: #e04787;">
                                    <svg width="15" height="15" viewBox="0 0 13 13">
                                        <path
                                            d="M6.49122 6.32693C6.39192 6.32693 6.31152 6.40742 6.31152 6.50663C6.31152 6.60594 6.39201 6.68633 6.49122 6.68633C6.59052 6.68633 6.67092 6.60585 6.67092 6.50663C6.67092 6.40733 6.59044 6.32693 6.49122 6.32693ZM6.49122 6.62327C6.42676 6.62327 6.37458 6.57106 6.37458 6.50663C6.37458 6.4422 6.42679 6.39 6.49122 6.39C6.55565 6.39 6.60786 6.4422 6.60786 6.50663C6.60789 6.57106 6.55568 6.62327 6.49122 6.62327Z" />
                                        <path
                                            d="M6.63544 6.15866C6.57101 6.15566 6.41141 6.1558 6.34692 6.15866C6.29025 6.16132 6.24027 6.175 6.19997 6.2153C6.13262 6.28265 6.14123 6.37341 6.14123 6.5065C6.14123 6.64272 6.13364 6.73137 6.19997 6.7977C6.26758 6.86529 6.35965 6.85644 6.49117 6.85644C6.6261 6.85644 6.67267 6.85653 6.72038 6.83806C6.78525 6.81288 6.83422 6.75489 6.83901 6.65075C6.84204 6.58628 6.84187 6.42672 6.83901 6.36223C6.83323 6.23929 6.76725 6.16473 6.63544 6.15866ZM6.73743 6.75314C6.69328 6.79729 6.63202 6.79335 6.49032 6.79335C6.34441 6.79335 6.28591 6.79551 6.24321 6.7527C6.19404 6.70377 6.20294 6.62518 6.20294 6.50604C6.20294 6.34481 6.1864 6.2287 6.34821 6.22041C6.38538 6.2191 6.39633 6.21866 6.48991 6.21866L6.49122 6.21954C6.64673 6.21954 6.76874 6.20325 6.77606 6.36503C6.77773 6.40195 6.7781 6.41304 6.7781 6.50647C6.77808 6.65069 6.78082 6.70955 6.73743 6.75314Z" />
                                        <path
                                            d="M6.67798 6.36178C6.70117 6.36178 6.71997 6.34298 6.71997 6.31979C6.71997 6.2966 6.70117 6.2778 6.67798 6.2778C6.65479 6.2778 6.63599 6.2966 6.63599 6.31979C6.63599 6.34298 6.65479 6.36178 6.67798 6.36178Z" />
                                        <path
                                            d="M9.13196 6.50726C9.13196 7.02936 8.97714 7.53973 8.68708 7.97384C8.39702 8.40795 7.98474 8.7463 7.50239 8.9461C7.02003 9.1459 6.48926 9.19817 5.9772 9.09631C5.46513 8.99446 4.99477 8.74304 4.62559 8.37387C4.25641 8.00469 4.005 7.53432 3.90314 7.02226C3.80128 6.51019 3.85356 5.97942 4.05336 5.49707C4.25316 5.01471 4.5915 4.60244 5.02561 4.31237C5.45972 4.02231 5.97009 3.86749 6.49219 3.86749C7.1923 3.86749 7.86374 4.14561 8.35879 4.64066C8.85384 5.13572 9.13196 5.80715 9.13196 6.50726Z" />
                                        <path
                                            d="M12.6654 1.83646C12.5339 1.49494 12.3322 1.18479 12.0734 0.925995C11.8146 0.667203 11.5044 0.465518 11.1629 0.333942C10.8839 0.226196 10.4626 0.0963628 9.6922 0.0613454C8.85717 0.0230956 8.60666 0.0150146 6.49215 0.0150146C4.37764 0.0150146 4.12713 0.0230951 3.2921 0.0608061C2.5201 0.0963622 2.10043 0.222425 1.82137 0.333942C1.47986 0.46563 1.16969 0.667349 0.910823 0.926121C0.651958 1.18489 0.450127 1.49499 0.318317 1.83646C0.210571 2.11552 0.0812765 2.53681 0.0457204 3.30719C0.00800935 4.14222 -0.000610352 4.39273 -0.000610352 6.50724C-0.000610352 8.62175 0.00800935 8.87226 0.0457204 9.70783C0.0812765 10.4798 0.207339 10.899 0.318317 11.178C0.45021 11.5195 0.652063 11.8296 0.910913 12.0885C1.16976 12.3473 1.47989 12.5492 1.82137 12.6811C2.10043 12.7888 2.52172 12.9187 3.2921 12.9537C4.12713 12.9919 4.3771 13 6.49215 13C8.6072 13 8.85717 12.9919 9.6922 12.9537C10.4642 12.9187 10.8839 12.7894 11.1624 12.6811C11.504 12.5494 11.8142 12.3476 12.0731 12.0887C12.332 11.8298 12.5338 11.5196 12.6654 11.178C12.7732 10.899 12.903 10.4777 12.9386 9.70783C12.9763 8.87226 12.9844 8.62175 12.9844 6.50724C12.9844 4.39273 12.9763 4.14222 12.9386 3.30719C12.903 2.53519 12.7743 2.11552 12.6654 1.83646ZM6.49215 10.5736C5.68791 10.5736 4.90173 10.3351 4.23302 9.88826C3.56432 9.44145 3.04313 8.80638 2.73536 8.06335C2.42759 7.32033 2.34706 6.50273 2.50396 5.71394C2.66086 4.92515 3.04814 4.2006 3.61682 3.63191C4.18551 3.06322 4.91006 2.67594 5.69885 2.51904C6.48764 2.36214 7.30524 2.44267 8.04827 2.75044C8.79129 3.05821 9.42636 3.5794 9.87318 4.24811C10.32 4.91681 10.5585 5.70299 10.5585 6.50724C10.5585 7.04123 10.4533 7.57 10.2489 8.06335C10.0446 8.5567 9.74507 9.00497 9.36748 9.38256C8.98988 9.76016 8.54162 10.0597 8.04827 10.264C7.55492 10.4684 7.02615 10.5736 6.49215 10.5736ZM10.7196 3.23015C10.5316 3.23015 10.3479 3.17441 10.1916 3.06999C10.0353 2.96557 9.91351 2.81715 9.84158 2.6435C9.76965 2.46985 9.75083 2.27878 9.7875 2.09443C9.82417 1.91009 9.91468 1.74076 10.0476 1.60785C10.1805 1.47495 10.3498 1.38444 10.5342 1.34777C10.7185 1.3111 10.9096 1.32992 11.0832 1.40185C11.2569 1.47378 11.4053 1.59558 11.5097 1.75186C11.6141 1.90814 11.6699 2.09188 11.6699 2.27983C11.6699 2.53187 11.5698 2.77359 11.3915 2.95181C11.2133 3.13003 10.9716 3.23015 10.7196 3.23015Z" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/SZOlympiads" target="_blank">
                                    <svg width="15" height="14" viewBox="0 0 13 12">
                                        <path
                                            d="M8.10133 4.95035L12.5911 0H10.8861L7.36169 3.8843L4.66349 0H0L4.72103 6.79234L0 11.9954H1.70496L5.4601 7.85667L8.33707 12H13L8.10133 4.95035ZM2.40325 1.275H4.02944L10.5962 10.729H8.97057L2.40325 1.275Z" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/silverzonefoundation" target="_blank"
                                    style="background-color: #e04787;">
                                    <svg width="13" height="13" viewBox="0 0 11 11">
                                        <path
                                            d="M11 11V6.97126C11 4.99126 10.5737 3.47876 8.26373 3.47876C7.14998 3.47876 6.40749 4.08376 6.10499 4.66126H6.07749V3.65751H3.89124V11H6.17374V7.35626C6.17374 6.39376 6.35249 5.47251 7.53499 5.47251C8.70374 5.47251 8.71749 6.55876 8.71749 7.41126V10.9863H11V11Z" />
                                        <path d="M0.178711 3.6575H2.46121V11H0.178711V3.6575Z" />
                                        <path
                                            d="M1.32 0C0.59125 0 0 0.59125 0 1.32C0 2.04875 0.59125 2.65375 1.32 2.65375C2.04875 2.65375 2.64 2.04875 2.64 1.32C2.64 0.59125 2.04875 0 1.32 0Z" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-2 col-md-6">
                <div class="el-footer-menu">
                    <h4>Product</h4>
                    <ul>
                        <li><a href="">E-Books</a></li>
                        <li><a href="">Phisical Books</a></li>
                        <li><a href="">Mock test</a></li>
                        <li><a [routerLink]="['/faq']">Faq</a></li>
                    </ul>
                </div>
            </div> -->
            <div class="col-lg-2 col-md-6"></div>
            <div class="col-lg-2 col-md-6">
                <div class="el-footer-menu">
                    <!-- <h4>Support</h4> -->
                    <div class="d-none d-sm-block"><br><br><br></div>
                    <ul>
                        <li><a href="">Profile</a></li>
                        <li><a [routerLink]="['/contact']">Contact Us</a></li>
                        <li><a [routerLink]="['/faq']">FAQs</a></li>


                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">
                <div class="el-footer-menu">
                    <!-- <h4>Important Links</h4> -->
                    <div class="d-none d-sm-block"><br><br><br></div>
                    <ul>
                        <li><a [routerLink]="['/privacy-policy']">Privacy Policy</a></li>
                        <li><a [routerLink]="['/terms-conditions']">Terms & Condition</a></li>
                        <li><a [routerLink]="['/cancellation-refund-policy']">Refund Policy</a></li>
                    </ul>
                </div>

            </div>

        </div>
        <div class="el-copyright-parent text-center">
            <p>Copyright © 2025 powerprep.silverzone.org. All Right Reserved</p>
        </div>

    </div>
    <div class="row" style="display: block; margin-bottom: 50px;">
        <div class="footer-name">
            <h2 class=""> PowerPrep Olympiad </h2>
        </div>
    </div>
    <div>



        <div class="pulse"></div>
        <div class="pulse"></div>
        <div class="pulse"></div>
        <a style="color: #fff" target="blank"
            href="https://api.whatsapp.com/send?phone=919289077795&text=Thank you for reaching out to SilverZone Foundation. Please write your query."
            target="_blank" class="whatsapp-info pulse"> <span class="whatsapp">
                <i class="fa fa-whatsapp"></i>
            </span>
        </a>

        <!-- <span class="intro-banner-vdo-play-btn">
            <div class="whatsapp-wrapper">
                <a target="_blank"
                    href="https://api.whatsapp.com/send?phone=919289077795&text=Thank you for reaching out to SilverZone Foundation. Please write your query.">
                    <i class="fa fa-whatsapp fa-2x"></i>
                </a>
            </div>
            <span class="ripple pinkBg"></span>
            <span class="ripple pinkBg"></span>
            <span class="ripple pinkBg"></span>
        </span>
 -->


        <!-- <a target="_blank"
            href="https://api.whatsapp.com/send?phone=919289077795&text=Thank you for reaching out to SilverZone Foundation. Please write your query."
            class="whatsapp-button"><i class="fa fa-whatsapp"></i></a> -->
    </div>
</div>

<!-- Footer End -->